<template>
  <Button
    data-sidebar="trigger"
    variant="ghost"
    size="icon"
    :class="cn('tw:size-7', props.class)"
    @click="toggleSidebar"
  >
    <slot>
      <PanelLeft />
    </slot>
    <span class="tw:sr-only">Toggle Sidebar</span>
  </Button>
</template>

<script setup>
import { PanelLeft } from '@lucide/vue'
import { Button } from '@/shadcn/components/ui/button'
import { cn } from '@/shadcn/lib/utils'
import { useSidebar } from './utils'

const props = defineProps({
  class: { type: null, required: false },
})

const { toggleSidebar } = useSidebar()
</script>
